<template>
    <div>
        <header id="header" role="banner">
            <div class="container">
                <div class="nav_container">
                    <a href="/" class="logo" aria-label="Grow With Stocks home"><img src="../assets/gws-logo-new.png" alt="Grow With Stocks"></a>
                    <button class="btn btn-lg btn-pink" @click="scrollTo">Join Now</button>
                </div>
            </div>
        </header>
        <main id="main-content" tabindex="-1">
        <section class="hero">
            <div class="container">
                <div class="hero_description ">
                    <div class="row">
                        <div class="col-12">
                            <h1>
                                KNOWLEDGE IS POWER: EDUCATE YOURSELF AND TURN SMALL INVESTMENTS INTO BIG RETURNS!
                            </h1>
                            <h6 class="mt-5">
                                Investing in unconventional fundamentally strong growth stocks could help you beat the market and build wealth.
                            </h6>
                            <button class="btn btn-pink btn-lg" @click="scrollTo">Join Now</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="description">
            <article>
                <img src="../assets/zentec.png" alt="Zen Technologies Ltd stock price chart showing 750% growth since August 2020">
                <div>
                    <h4 class="text-center mt-4">
                      <strong>
                          Zen Technologies Ltd is up by <span class="text-green"> +750% </span> since August 2020 and still going strong.
                        </strong>
                    </h4>
                    <h6 class="text-desclaimer mb-4">(as of 24 November 2023)</h6>
                </div>
                <p>
                    Dear Investor
                </p>
                <p>
                    Do you ever feel like entering the stock market is a daunting task? You're not alone. 
                    </p>
                    <p>
                    Many individuals dive in without the right guidance, knowledge, or support, leading to frustrating losses and disappointment. 
                    </p>   
                    <p>
                    At Grow with Stocks, we understand your pain.
                    </p>   
                    <p>
                    But here's the thing: while some investors are reaping incredible returns of <span> 300%, 400%, or even 10 times </span> their initial investment, it seems that success eludes you. 
                    </p>   
                    <p>
                    Instead, you've either experienced mediocre returns or encountered significant losses. It's time to break free from this cycle of frustration.
                    </p>   
                    <p>
                    Let us share one crucial secret with you: with the right approach, it is possible to achieve outstanding returns.
                    </p>
                    <p>
                    For example, Avantel Ltd., has already provided a <span> staggering 30% return in just one month and nearly 4.5 times return in less than nine month.</span>
                </p>
                <img src="../assets/article.png" alt="Article excerpt featuring Grow With Stocks investor returns">
                <p>
                    But hold onto your seat because the real game-changer is the potential to <span> earn 300% to 500% in a couple of years </span>– that's how wealth is created in the stock market.
                    </p>
                    <p>
                    Now envision this: our clients, just like you, once relied on generic tips, short-term calls, and social media chatter.
                    </p>
                    <p>
                    Consequently, they experienced losses and disappointment.
                    </p>
                    <p>
                    But since joining us, their fortunes have transformed.
                    </p>
                    <p>
                    With just a single monthly recommendation from us, our clients have made remarkable gains <span> 250%, 300%, and even 400%. </span>
                    </p>
                    <p>
                    These individuals have shifted their mindset towards long-term investing, compound growth, and recognizing the vast potential of multi bagger stocks and the Indian market over the next 5 to 10 years.
                    </p>
                    <p>
                    Picture this: clients who started initially with a mere Rs 5k - Rs 10k per month in 2014 now boast portfolios approaching 1 crore in just 7 to 8 years.
                    </p>
                    <p>
                    At Grow with Stocks, we have a clear objective: to provide high growth stocks.
                    </p>
                    <p>
                    We're not idealists; we understand that long-term investing is a proven strategy that saves you time, money, and headaches while exponentially growing your wealth.
                    </p>
                    <p>
                    So the real question is for you now
                    </p>
                    <p>
                    Do you want to wait another five to six years for the next bear market?
                    </p>
                    <p>
                    Of course you don’t.
                    </p>
                    <p>
                    The next step is the easiest one you will ever make.
                    </p>
                    <p>
                    Just click the button below to get started.
                </p>
                <button class="btn btn-pink btn-lg mt-2" @click="scrollTo">Get started</button>
            </article>
        </section>
        <section class="stocks">
            <div class="container">
                <h3>Here are some of the winners over the Past Decade</h3>
                <p class="text-desclaimer">
                    *Disclaimer: "The securities quoted are for illustration only and are not recommendatory" <br>
                    *Note: The past performance is not an indicator of future performance.
                </p>
                <div class="row">
                    <div class="col-md-6 col-xs-12 mb-4" v-for="stock in stocks" :key="stock.slug">
                       <div class="stock_card pa-4">
                            <div class="row">
                                <div class="col-md-2 col-sm-12">
                                   <img :src="require(`../assets/${stock.slug}-logo.png`)" :alt="`${stock.name} company logo`" class="img-logo">
                                </div>
                                <div class="col-md-10 col-sm-12">
                                    <h5 class="pull-right">{{ stock.name }}</h5>
                                </div>
                            </div>
                            <img :src="getImgUrl(stock.slug)" alt="" class="img-responsive">
                        </div>
                    </div>
                </div>
               
                <button class="btn btn-lg d-block btn-pink mx-auto my-5" @click="scrollTo">Get Started</button>
            </div>
        </section>
        <section class="testimonials">
            <div class="container">
                <h3 class="mb-5">Real people, Real reviews</h3>
                 <div class="row">
                    <div class="col-md-6 col-xs-12 pa-3" v-for="item in testimonials">
                        <div class="testimonial_card elevation-1">
                            <h4>{{ item.name }}</h4>
                            <img src="../assets/5-star.png" alt="5 out of 5 star rating" class="my-2">
                            <p v-html="item.description"></p>
                        </div>
                    </div>
                </div>                 
            </div>
        </section>
        <section class="whats_included">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-xs-12 whats_included_image">
                        <img src="../assets/whats-included-latest.png" alt="Avantel Ltd stock chart showing 350% gain since March 2023" class="img-responsive">
                        <h4 class="text-center mt-4">
                            Avantel Ltd  is up by <span class="text-green"> +350% </span> since march 2023 and still going strong.
                        </h4>
                        <p class="text-desclaimer">(as of 24 November 2023)</p>
                    </div>
                    <div class="col-md-6 col-xs-12 py-4">
                        <h3>What's included</h3>
                        <p>
                            With Grow with stocks membership you will receive comprehensive 10-page research report containing with the following insights. 
                        </p>
                        <p>
                            Even if you're short on time, reading the last 3 to 4 pages will put you ahead of 90% of the investors.
                        </p>
                        <ul>
                            <li>
                               <img src="../assets/check-purple.png" alt=""> What the company does
                            </li>
                            <li>
                               <img src="../assets/check-purple.png" alt=""> Why invest in this stock
                            </li>
                            <li>
                                <img src="../assets/check-purple.png" alt=""> Growth potential for this stock in near future
                            </li>
                            <li>
                                <img src="../assets/check-purple.png" alt=""> Should you buy now or wait for a specific price range
                            </li>
                            <li>
                                <img src="../assets/check-purple.png" alt="">  When to exit from this stock 
                            </li>
                        </ul>
                        <button class="btn-pink btn btn-lg mt-4" @click="scrollTo">Get Started</button>
                    </div>
                </div>
            </div>
        </section>
        <section class="feature">
            <div class="container">
                <h3 class="mb-4">Some of our Key Features Include</h3>
                <h4 class="mb-4 w-75">We believe that Consistency, Guidance and Updates makes a great investor, not stock ideas or tips.We offer Recommended Stocks Advisory reports.</h4>
                <div class="row">
                    <div class="col-md-6 col-xs-12 pa-2" v-for="feature in features" :key="feature.title">
                        <div class="feature_card">
                            <h4>{{ feature.title }}</h4>
                            <p>{{ feature.description }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="pricing" ref="pricing" id="pricing">
            <div class="container">
               <div class="row">
                    <div class="col-md-4 col-xs-12">
                        <div class="pricing_content">
                            <h3>Get Access to High-Growth Stocks with Huge Upside</h3>
                            <p>
                                Discover Non-conventional, Market-Beating & Wealth-Building Stocks to maximise your Profits through research and knowledge based real market facts.
                            </p>
                            <p>
                                Enhance Your Investing Acumen and Identify Tomorrow's Market Leaders. Find out which companies are the best stocks to invest in today
                            </p>
                            <p>
                                Don't Miss Out
                            </p>
                        </div>
                    </div>
                     <div class="col-md-4 col-xs-12">
                        <div class="pricing_card mt-5 mb-3">
                            <div class="limited">
                                <img src="../assets/star.png" class="mr-2" alt="" aria-hidden="true">
                                <span>Limited Time Offer</span>
                            </div>
                            <h4>Starter Plan</h4>
                            <div class="offer_pricing">
                                <span class="new">Rs.199/-</span>
                            </div>
                            <ul> 
                                <li class="" v-for="item in pricingFeatures" :key="item">
                                   <img src="../assets/check-blue.png" alt="" role="presentation" />
                                    {{ item }}
                                </li>
                            </ul>
                             <div class="pricing_card_footer">
                               <a href="https://rzp.io/l/OU2ngE1Uoa" target="_blank" rel="noopener noreferrer" aria-label="Get started with the Starter Plan (opens payment page in a new tab)">
                                    <button class="btn btn-block btn-lg" type="button">
                                        Get Started
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-xs-12">
                        <div class="pricing_card">
                            <div class="limited">
                                <img src="../assets/star.png" class="mr-2" alt="" aria-hidden="true">
                                <span>Limited Time Offer</span>
                            </div>
                            <h4>1 Year Subscription Plan</h4>
                            <div class="offer_pricing">
                                <span class="old">Rs.35,000</span> <span class="new">Rs.20,999</span>
                            </div>
                            <ul> 
                                <li class="" v-for="item in subscriptionPricingFeatures" :key="item">
                                   <img src="../assets/check-blue.png" alt="" role="presentation" />
                                    {{ item }}
                                </li>
                            </ul>
                             <div class="pricing_card_footer">
                                <a href="https://rzp.io/l/vilE1Ln6" target="_blank" rel="noopener noreferrer" aria-label="Get started with the 1 Year Subscription Plan (opens payment page in a new tab)">
                                    <button class="btn btn-block btn-lg" type="button">
                                        Get Started
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
               </div>
            </div>
        </section>
        <section class="money_back py-3">
            <div class="container">
                <div class="row">
                    <div class="col-xs-6 col-xs-offset-3 col-md-3 col-md-offset-0">
                        <img src="../assets/30 days.png" alt="" class="img-responsive">
                    </div>  
                    <div class="col-xs-12 col-md-9">
                        <div class="">
                            <h3>30-Day Satisfaction Guarantee</h3>
                            <p>
                                We’re so confident you’ll love Grow With Stocks that we offer new members a risk free 30 day money back guarantee. If you’re not happy simply email us at <a href="mailto:info@growwithstocks.com"> info@growwithstocks.com </a> and let us know why. We’ll process a full refund – no questions asked.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="faq">
            <div class="container">
                <h3 class="text-center">Frequently asked questions</h3>
                <p class="text-center mb-5">Everything you need to know about the product and billing.</p>

                <div class="my-5" v-for="item in faq">
                    <h4>{{ item.question }}</h4>
                    <p>
                        {{ item.answer }}
                    </p>
                </div>
            </div>
        </section>
        <section class="form">
            <div class="container">
                <h3>Don't miss out on valuable insights! Join our Investor community today and receive a complimentary stock report</h3>

                <div class="row">
                    <div class="col-xs-12 col-md-6 col-md-offset-3">
                        <form v-on:submit.prevent="saveData" class="mt-5">
                            <v-text-field
                            v-model="name"
                            label="Name"
                            solo
                            size="small"
                            autocomplete="name"
                            :error-messages="nameErrors"
                            required
                            @input="$v.name.$touch()"
                            @blur="$v.name.$touch()"
                            ></v-text-field>

                            <v-text-field
                            v-model="email"
                            :error-messages="mobileErrors"
                            label="Email"
                            required
                            type="email"
                            autocomplete="email"
                            solo
                            rounded
                            @input="$v.email.$touch()"
                            @blur="$v.email.$touch()"
                            ></v-text-field>

                            <vue-phone-number-input color="#000000" default-country-code="IN" v-model="phone" required :border-radius="2" :countries-height="20" size="lg" class="input_mobile" label="Mobile" @update="handlePhoneChange"/>
                            <button class="btn btn-block btn-pink btn-lg my-4">{{loading ? 'Saving' : 'Join Now'}}</button>
                        </form>
                    </div>
                </div>

            </div>
        </section>
        </main>
        <footer>
            <p>
                Email us at <span> info@growwithstocks.com </span>
            </p>
            <p>
                or
            </p>
            <p>
            For any enquiries call us at <span> +91 9271212131 </span>
            </p>
            <div class="row">
                <div class="col-12 col-md-4 col-md-offset-4">
                    <div class="footer_extra_info">
                <div class="ml-2 my-5">
                    <p>
                    <strong>
                        PROPRIETOR GROW WITH STOCKS) GOUTAM SHARMA, Research Analyst
                        <br/>
                        </strong>
                        SEBI (Research Analysts) Regulations 2014, Registration No. INH000001212
                        <br>
                        <br>
                        120, SHASTRI NAGAR, BEHIND RAM MANDIR,
                        JAMMU, Jammu & Kashmir - 411006

                            <br>
                        <strong>
                            Telephone:
                        </strong>
                        +91-9271212131
                        <br>
                        <strong> Email: </strong> info@growwithstocks.com, growwithstocks@gmail.com 
                        <br>
                        <strong>Website:
                        </strong>
                        www.growwithstocks.com
                        <br>

                            <br>
                            <strong>

                            <i>
                                Grievance Officer: Mr Goutam Sharma
                            </i>
                            </strong>
                        <br>
                        Telephone: +91-9271212131 | Email: growwithstocks@gmail.com
                    </p>
                    </div>
                
                    <div class="footer_extra_info">
                        
            <p>
                <strong>Legal Disclaimer : </strong>
                <br>
                Investment in securities market are subject to market risks. Read all the related documents carefully before investing.
                <br>
                <br>
                Registration granted by SEBI and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.
                <br>
                <br>
                Grow With Stocks, Goutam Sharma bearing Registration No. INH000001212  is an  individual Research Analyst. Information herein should be regarded as a resource only and should be used at one's own risk. This is not an offer to sell or solicitation to buy any securities and  Grow With Stocks, Goutam Sharma will not be liable for any losses incurred or investment(s) made or decisions taken/or not taken based on the information provided herein. Information contained herein does not constitute personalized advice or a personal recommendation or take into account the particular investment objectives, financial situations, or needs of individual subscribers.
                <br>
                <br>
            </p>
            </div>
                </div>
                
            </div>
            </div>

            <p>Read 
                <span>
                    <a href="/disclaimer" target="_blank" rel="noopener noreferrer">
                        Disclaimer 
                    </a>
                </span>
            </p>
        </footer>
    </div>
</template>

<script>
import Vue from 'vue'
import { required, maxLength, numeric, email } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import VuePhoneNumberInput from 'vue-phone-number-input';
import axios from 'axios';

Vue.component('vue-phone-number-input', VuePhoneNumberInput);


export default {
    mixins: [validationMixin],
    validations: {
        name: { required },
        phone: { numeric, required, maxLength: maxLength(10) },
        email: {  required }
    },
    computed: {
      mobileErrors() {
        const errors = [];
        if (!this.$v.phone.$dirty) return errors;
        !this.$v.phone.required && errors.push("Mobile Number is required.");
        !this.$v.phone.maxLength && errors.push("Enter correct Mobile Number.");
        return errors;
      },
      nameErrors() {
        const errors = [];
        if (!this.$v.name.$dirty) return errors;
        !this.$v.name.required && errors.push("Name is required.");
        return errors;
      },
      emailErrors() {
        const errors = [];
        if (!this.$v.email.$dirty) return errors;
        !this.$v.email.required && errors.push("Email is required.");
        return errors;
      },
    },
    data() {
        return {
            loading: false,
            name: null,
            phone: null,
            email: null,
            phoneFormatted: null,
            stocks: [
                {
                    name: "Acrysil India (400% returns)",
                    slug: "acrysil",
                },
                {
                    name: "Atul Auto (512% returns)",
                    slug: "atul",
                },
                {
                    name: "Cera Sanitaryware (700% returns)",
                    slug: "cera",
                },
                {
                    name: "Finolex cables (180%returns)",
                    slug: "finolex",
                },
                {
                    name: "Amara Raja Batteries (188% returns)",
                    slug: "amara",
                },
                {
                    name: "Astral Poly Technik (453% returns)",
                    slug: "astral",
                },
                {
                    name: "Superhouse (161% returns)",
                    slug: "superhouse",
                },
                {
                    name: "Suprajit Engineering (350% returns)",
                    slug: "suprajit",
                },
            ],
            features:[
                {
                    title: "Guidance on your past portfolio",
                    description:"In case you want to know our opinions & suggestions regarding any particular script in your previous holding, we will try our best to help you out."
                },
                {
                    title: "Market - beating stock recommendations",
                    description:"Expert stock recommendations carefully aimed at multiplying net worth."
                },
                {
                    title: "Hard-hitting and Profit-Yielding stocks",
                    description:"Stocks which are like hidden-gems & poised to grow and can produce 2x, 3x, 5x returns.",
                    note:'*Note: The past performance is not an indicator of future performance.'
                },
                {
                    title: "Complete guide for New Beginners in the world of Stocks",
                    description:"Whether you are a beginner or an experienced investor, you need the right strategy. Therefore, you’ll receive a 10-min personalised strategy call prior to your first stock purchase."
                },
                {
                    title: "Unconventional growth stocks to maximize your returns",
                    description:"Investing into companies which may be small or midsize today but are poised to become big in the near furture is how you beat the market."
                },
                {
                    title: "Recommendations based on thorough research and fundamental analysis",
                    description:"We do the research, we do the fundamental analysis, so that you can simply sit back, invest and fetch returns."
                },
                {
                    title: "Targeting the  long-term returns",
                    description:"Sooner or later, you realise that targeting long term returns is how you actually create wealth in the market and compound your returns. "
                },
                {
                    title: "Clear Buy, Sell and Hold updates",
                    description:"You will receive the necessary timely updates."
                },
            ],
            testimonials:[
                 {
                    name : 'Vinayak Hiremath',
                    
                    description: `Time is Money. Time has gone by Rocket Speed over the last few years ,So did returns on my stock Investments!!
                    <br>
                    <br>
                    I have been member of GWS group over last 3-years. It was indeed a very fruitful investment journey with Grow With Stocks (GWS).
                    My financial health has improved by leap and bounds with periodic and strategic investments through the guidance of GWS members.
                    I am very glad to say the returns on investment made has given in multiples of 100 %, 200% & 500 % compared to single digit growth, when I used to invest my own terms.
                    <br>
                    <br>
                    Also the multiple earnings helped me to revisit & explore my plans like Photography expeditions tours, Europe tour with family & Interior decoration for my new home etc... 
                    I want thank GWS for the opportunities over last few years & Wish you all the best for your investments. 
                    <br>
                    Happy Investing to all !!!`
                },
                {
                    name :'Jay Shah',
                    slug:'jay',
                    description:'I Joined GWS services 4 years ago and here is my honest review on it. I would like to say that I am in stock market because of “GWS". My total investment in last 4 years is 7 Lacs and I have returns of 21+ Lacs because of GWS. There is no other way, that could have made this kind of return, so I am very thankful to GWS   family. I would like to mention that within 2 years many stocks in my portfolio made huge returns like 3 to 6 times. I am very happy with GWS. '
                },
                {
                    name :'Rajeev S',
                    description:`Grow With Stocks recommendations are based on pure fundamentals of the company.  Their stock-picks are thoroughly analysed and researched before they are advised for investments to the clients.
                    One can proudly say that through GWS one invests into the businesses of the company, thereby by being part of the company and as a shareholder participates in the growth of the company, and more importantly derives excellent returns on the investments made. 
                    <br>
                    <br>
                    As I have observed, many of their stock-picks are recommended at a very early phase, before a Mutual Fund Manager or an FPI/FII would have identified and picked it up.  GWS provides the edge over others by constant and continuous monitoring of their investments. As a result, the growth of one’s wealth is synonymous with GWS!
                    I am very glad to be associated with Mr.Gautham Sharma for 8 years now.  True to his name, ‘Gautham’ has removed the myth and darkness about the stock markets providing invaluable insights and enlightening on the prospects and growth of investments in the stock market.
                    I would highly recommend GWS to every prudent investor who would like to grow one’s wealth.
                    Thanks is only a small word for the sterling commitment of Mr. Gautham Sharma and GWS.`
                },
                {
                    name : 'Pramod kudchadkar',
                   
                    description: `I have been your subscriber for almost 4 years. I am happy to inform you that Grow with stocks has given me more wealth than my retirement career. During my 35 years of investing, I have never seen some stocks skyrocketing from 6 times to as high as 18 times within a span of 12 months. In view of the windfall profits, I could invest a part of it
                        in real estate and the rest to build my portfolio.
                        <br>
                        I wish Grow with stocks all the best in the years to come.`
                },
                {
                    name : 'Satish Abde',
                    description: `For more than three decades, I have been investing in the stock market. Time to time,I have consulted many share consultant firms. Finally I have stopped searching for new firms, investing with the consultation of "GROW WITH STOCKS " for more than three years. Many of the stocks recommended by the above firm fetched like 300% in a year or so. My best wishes TO " GROW WITH STOCKS" in the years to come.`
                },
                {
                    name : 'Jayarajan M Varkala',
                    description: `I am a member of Grow With Stocks since 2013. The Investment of mine in year 2013 has appreciated to more than 100% during the period of 17 months. I am very happy to recommend G.W.S Consultants to any of my friends interested in having consultancy services to help their investment in the Equity Market. Their monthly recommendation of Stocks, weekly/fortnightly personal contacts helps to generate and maintain a highly profitable portfolio.`
                },
                {
                    name : 'Kamalesh Khut',
                    description: `My name is Kamalesh, having small business in Mumbai. I on  recommendation from GROW WITH STOCKS to sell IDFC and buy Escort ltd helped me to revive my portfolio value. There were days when I had a loan against security and it was only because of escort my other shares which were pledged were   not liquidated by bank or else I would be landed up in problem. I sold IDfC and bought escort when the rates of both were same i.e @ approx 135. Now the market rate is 550. It went above 1000 however I did not book profit. I am still holding the stock. Let's see what the future for me.`
                },
                {
                    name:'Gayathri Umachandran',
                    description: `
                    I had started trading a few years back, but mostly did it from random suggestions I got from news channels and through some irregular study. Only in the year 2014, I had made my association with GROW WITH STOCKS and took an annual subscription. 
                    I have not repented ever since. They have not only made me richer monetarily but also knowledgeable. The fact that I recommend it to my friends and even mentioned it in my Facebook status, shows my respect for the GROW WITH STOCKS team.`
                },
                {
                    name:'Hardik Patwa, Mumbai',
                    description: `
                    Grow With Stocks find hidden gems at very attractive price. Their recommendations are based on plain business fundamentals and they do not encourage trading. 
                    They believe in Investment philosophy with a horizon of at least 1-2 years. I recommend GWS to everyone who would like to become a better investor and make money in the
                    stock market.`
                }
            ],
            pricingFeatures:[
                'Personalised guidance on your existing portfolio from registered Research Analyst with over 12 years of experience.',
                'Enjoy a 15-minute personalised call to discuss your investment strategy.',
                '1 latest complimentary stock recommendation' 
            ],
            subscriptionPricingFeatures:[
                '12 number of stocks in a year ( 1 per month )',
                'Hard hitting and profit yielding stocks with detailed research report',
                'Regular updates on every stock',
                'Clear Buy, Sell and Hold instructions',
                '15 mins personalised strategy call prior to your first stock',
                'Capital allocation strategy',
                'Guidance on your past portfolio ( optional )',
                'Complete guide for new beginners',
                'Articles, strategies to increase you investing acumen'
            ],
            faq: [
                {
                    question: "Who is Grow With Stocks best suited for?",
                    answer:
                    "Are you constantly missing out on great stocks before they soar? Tired of hearing about them only after the price skyrockets? Struggling to choose the right stock to invest in? Don't have the time or resources for exhaustive research? Look no further than Grow With Stocks – your ultimate solution!",
                },
                {
                    question: "Who is Grow With Stocks not suited for?",
                    answer:
                    "Trying to find a stock you can pump and dump this week? Want to make a quick buck overnight? Looking for intra-day trading tips? Grow With Stocks is not for you. We only send high-quality stock ideas that have long-term value.",
                },
                {
                    question: "Can I have a preview of your previous recommendation(s)?",
                    answer: "Yes. Yes you can request for a couple of sample reports for your reference.",
                },
                {
                    question: "Are you interested in investing, but afraid of losses?",
                    answer:
                    "Well, you're not alone. We totally understand your fear. You're investing your hard-earned money to grow your investment returns. The truth is that loss can happen in a couple of stocks out of a dozen stocks. Even the world's best investors pick the occasional dud. But that’s a part of the game. The successful investors understand that if you buy and hold for the long term, it's possible one of your investments could go down by 50 - 60%. But the rest of the stocks can give you many times more than you could ever lose. With our highly curated quality stocks, your winners will outperform the losers in your portfolio. It’s the net returns which makes the difference in the end. That strategy has helped hundreds and hundreds of our investors build wealth and beat the market. In case, you still have some doubts, you can clarify those while having a 10 minutes’ strategy call with our experts.",
                },
                {
                    question: "What is the average holding period of each stock?",
                    answer:
                    "The average holding period is usually 2-3 years, but we have seen in the past when few of our stocks have achieved its target within 6-8 months.",
                },
                {
                    question: "Do you provide timely updates including buy, sell(exit) call?",
                    answer:
                    "Yes. At Grow With Stocks, we not only offer timely buy and sell alerts, but we also keep you informed about when to add more to your existing shares.",
                },
            ]

        }
    },
    mounted(){
        // When the user scrolls the page, execute myFunction
        window.onscroll = function() {myFunction()};

            // Get the header
            var header = document.getElementById("header");

            // Get the offset position of the navbar
            var sticky = header.offsetTop;

            // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
            function myFunction() {
                if (window.pageYOffset > sticky) {
                    header.classList.add("sticky");
                } else {
                    header.classList.remove("sticky");
                }
        }
    },
    methods:{
        getImgUrl(item) {
            try {
                return require(`../assets/${item}.png`)
            } catch(e){
                console.error(e)
            }
        },
        handlePhoneChange(e){
            this.phoneFormatted = e.formatInternational;
        },
        openRazorPay(){
            window.open('https://rzp.io/l/vilE1Ln6', '_blank');
        },
        openRazorPayFirst(){
            window.open('https://rzp.io/l/OU2ngE1Uoa', '_blank');
        },
        scrollTo(){
            const myEl = this.$refs.pricing;
            this.$smoothScroll({
            scrollTo: myEl,
            offset: -100, // optional,         
            hash: '#pricing'  // required if updateHistory is true
            })
        },
        saveData(){
            this.loading = true;

            axios.post('https://api.convertkit.com/v3/forms/5877943/subscribe', 
                {
                    "api_key": 'VaRRMlAtpnBdnkb5UPnYqg',
                    "email": this.email,
                    "first_name": this.name,
                    fields:{
                        "phone_number": this.phoneFormatted
                }
                
            })
            .then(res => {
                fbq('track', 'Lead');
                this.loading = false;
                window.localStorage.setItem('name', this.name);
                window.localStorage.setItem('phone', this.phoneFormatted);
                this.$router.push(`/welcome`);
            })
            .catch(err => {
                this.loading = false;
                    this.$toasted.error(err, {
                    duration: 2000,
                    position: "bottom-right"
                });
            });
        },
    }
}
</script>



<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600;700&display=swap');
h1,h2,h3,h4,h5,h6,p,span,button{
   font-family: 'Figtree', sans-serif;
}

.flex-column{
    flex-direction: column;
}

section{
    margin-bottom: 40px;
    // /* min-height: 70vh;
}


.btn-pink{
    border-radius: 8px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    background-color: #C33990;
    color: #fff;
}

.text-green{
    color: #069E03;
}
.text-desclaimer{
    text-align: center;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 200% */
}
h3{
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 48px; /* 100% */
    @media screen and (max-width: 768px) {   
        font-size: 35px;
        line-height: 120%; 
    }
}

.sticky {
  position: fixed;
  top: 0;
  width: 100%;
  z-index:1000;
  transition: 500ms;
}
nav{
    background-color: #1f2730;
    border-bottom: 1px solid rgba(255,255,255,0.1) ;
    .nav_container{
        .logo{
            img{
                width: 100%;
                max-width: 200px;
            }
        }
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
.hero{
    background-color: #1f2730;
    color: #F1F5F9; 
    min-height: 70vh;
    padding: 40px;
    margin-bottom: 0px;

    @media screen and (max-width: 768px) {   
        padding: 20px;
    }
    .hero_description{
        flex-direction: column;
        justify-content: center;
        align-items: center;
        h1 {
            text-align: center;
            font-size: 60px;
            font-style: normal;
            font-weight: 700;
            line-height: 120%; 
            @media screen and (max-width: 768px) {   
                font-size: 35px;
                line-height: 120%; 
            }
        }
        h6{
            text-align: center;
            width: 70%;
            margin: auto;
            font-size: 20px;
            font-style: normal;
            font-weight: 400;
            line-height: 28px; /* 140% */
            @media screen and (max-width: 768px) {   
                font-size: 16px;
                line-height: 28px;
                width: 100%;
            }
        }
        button {
            width: 100%;
            max-width: 300px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-weight: 500;
            margin: auto;
            margin-top:40px;
        }
    }
}
.description{
    padding: 40px;
    max-width: 768px;
    margin: auto;
    margin-bottom: 0px;
    min-height: auto;
    p{
        color: #1F2937;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 42px; /* 175% */
        span{
           background-color: #a7fc8a;
           font-weight: 700; 
        }
        @media screen and (max-width: 768px) {  
            font-size: 20px;
        }
    }
    img{
        width: 100%;
        border: 10px solid rgba(0,0,0,0.1);
        margin: 20px 0;
    }
}
.stocks{
    margin-bottom: 0px;
    min-height: auto;
    h3{
        @media screen and (max-width: 768px) { 
            font-size: 30px;
            line-height: 100%;
            text-align: center;
        }
    }
    .stock_card{
        background-color: #fff;
        border-radius: 8px;
        border: 1px solid #CBD5E1;
        min-height: 370px;
        position: relative;
        @media screen and (max-width: 768px) {  
             min-height: 200px;
        }
        .img-logo{
            max-height: 70px;
            max-width: 100px;
            @media screen and (max-width: 768px) { 
                max-height: 50px;
                max-width: 70px;
            }
        }
        h5{
            color: #387ed1;
            font-size: 18px;
            @media screen and (max-width: 768px) { 
                font-size: 16px;
                line-height: 36px;
                position:absolute;
                top: -35px;
                right: 0;
            }
        }
    }
}
.whats_included{
    padding: 60px 0;
    @media screen and (max-width: 768px) { 
        padding: 20px;
    }
    min-height: auto;
    margin-bottom: 0px;
    .whats_included_image{
        padding: 20px;
         @media screen and (max-width: 768px) { 
            padding: 8px;
        }
    }
    background-color: #F3F8FD;
    h3{
        color: #030303;
        text-align: center;
        font-style: normal;
        font-weight: 700;
        line-height: 150%; /* 36px */
        text-align: left;
        margin-top: 0;

    }
    h4{
        color: #030303;
        text-align: center;
        font-style: normal;
        font-size: 25px;
        font-weight: 700;
        line-height: 150%; /* 36px */
        text-align: left;
        margin-top: 0;
        @media screen and (max-width: 768px) { 
            font-size: 20px;
        }
    }
    p{
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px; /* 155.556% */
    }
    ul{
        padding: 0;
        li {
            display: flex;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 28px; /* 155.556% */
            margin: 15px 0;
            img{
                margin-right: 10px;
                @media screen and (max-width: 768px) { 
                    max-height: 30px;
                }
            }
            @media screen and (max-width: 768px) { 
               font-size: 18px;
            }
        }
    }
}
.feature{
    padding: 40px 0;
    background-color: #1f2730;
    color: #fff;
    text-align: center;
    font-family: Figtree;
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: 44px; /* 122.222% */
    letter-spacing: -0.72px;
    margin-bottom: 0px;
    min-height: auto;
    @media screen and (max-width: 768px) { 
        font-size: 28px;
        line-height: 36px;
    }
    p {
        text-align: center;
        font-family: Figtree;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px; /* 150% */
    }
    h4{
        @media screen and (max-width: 768px) { 
            font-size: 18px;
            line-height: 28px;
        }
    }
    .feature_card{
        padding: 20px;
        min-height: 230px;
        @media screen and (max-width: 768px) { 
            min-height: 150px;
        }
        background-color: #fff;
        text-align: left;
        h4{
            color: var(--colors-gray-900, #111827);
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: 30px; /* 125% */
            @media screen and (max-width: 768px) { 
                font-size: 20px;
            }
        }
        p{
            color: #374151;
            text-align: left;
             @media screen and (max-width: 768px) { 
                font-size: 16px;
                line-height: 22px;
            }
            
        }
    }
}
.testimonials{
    background-color: #f7f7f7;
    padding: 40px 0;
    margin-bottom: 0px;
    min-height: auto;
    @media screen and (max-width: 768px) { 
        padding: 20px;
    }
    h3{
        color: #0F172A;
        text-align: center;
        font-size: 40px;
        font-style: normal;
        font-weight: 600;
        line-height: 56px; /* 140% */
        letter-spacing: -1px;
        @media screen and (max-width: 768px) { 
            font-size: 30px;
            line-height: 40px; /* 140% */
        }
    }
    .testimonial_card{
        padding: 30px;
        height: 300px;
        background-color: #fff;
        text-align: left;
        overflow: scroll;
        border-radius: 8px;
        img{
            width: 100%;
            max-width: 100px;
        }
        h4{
            color:  #111827;
            font-size: 24px;
            font-weight: 600;
        }
        p{
            color: #374151;
            text-align: left;
            font-size: 14px;
        }
    } 
}
.pricing{
    padding: 40px 0;
    background-color: #F3F8FD;
    margin-bottom: 0px;
    min-height: auto;
    .pricing_content{
        margin: auto;
        h3{
            color: #111827;
            font-size: 40px;
            font-style: normal;
            font-weight: 700;
            line-height: 52.8px; /* 132% */
             @media screen and (max-width: 768px) { 
                font-size: 32px;
                line-height: 40px; /* 140% */
            }
        }
        p{
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 28px; /* 155.556% */
             @media screen and (max-width: 768px) { 
                font-size: 16px;
            }
        }
    }
    .pricing_card{
        position: relative;
        .offer_pricing{
            .old{
                color:  #94A3B8;
                font-family: Figtree;
                font-size: 24px;
                font-style: normal;
                font-weight: 400;
                line-height: 42px; /* 175% */
                text-decoration: line-through;
            }
            .new{
                color:  #334155;
                font-size: 32px;
                font-style: normal;
                font-weight: 600;
                line-height: 40px; /* 125% */
            }
        }
        .limited{
            display: flex;
            align-items: center;
            position:absolute;
            top:0;
            padding: 4px 6px;
            right: 0;
            font-family: Figtree;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 20px;
            border-radius: 0px 8px 4px 4px;
            background: #CEEDFA;
        }
        background: #fff;
        border-radius: 8px;
        padding: 24px;
        h4{
            color: #387ED1;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
        }
        ul {
            padding: 0;
            li{
                display: flex;
                margin: 15px 0;
                align-items: start;
                color:  #667085;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px; /* 150% */
                img{
                    margin-right: 10px;
                }
            }
        }
        .pricing_card_footer{
            background: rgba(0,0,0,0.1);
            button{
                margin-top: 30px;
                border-radius: 8px;
                border: 1px solid #387ED1;
                background: #387ED1;
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                color: #fff;
            }
        }
       
    }
}
.money_back{
    margin-bottom: 0px;
    min-height: auto;
    background-color: #1f2730;
    color: #fff;
    h3{
        margin: 20px 0;
        text-align: left;
        @media screen and (max-width: 768px) { 
            font-size: 30px;
            line-height: 40px; /* 140% */
            text-align: center;
        }
    }
    p{
        
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px; /* 150% */
        @media screen and (max-width: 768px) { 
            text-align: center;
            font-size: 18px;
        }
    }
    a{
        color: #fff;
        text-decoration: underline;
    }
}
.faq{
    padding: 40px 0;
    max-width: 768px;
    margin: auto;
    @media screen and (max-width: 768px) { 
        padding: 20px 0;
    }
}
.form{
    margin-bottom: 0px;
    min-height: auto;
    text-align: center;
    background-color: #1f2730;
    h3{
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        color: white;
         @media screen and (max-width: 768px) { 
            font-size: 28px;
        }
    }
    .input-tel{
        color: #030303 !important;
    }
    input{
        cursor: pointer;
        caret-color: black;
        color: #030303 !important;
    }
    .v-input{
        .v-input__control{
            .v-input__slot{
                .v-text-field__slot{
                    input{
                        color: #030303 !important;
                        caret-color: black !important;
                    }
                
                }
            }
        }
    }

    .input-tel{
        color: #030303 !important;
    }
    .input-tel__input{
        color: #030303 !important;
    }
    .input-phone-number{
        input{   
            color: #030303 !important;
        }
        input::focus{   
            color: #030303 !important;
        }
    }
    button{
        text-align: center;
        display: block;
    }
}
.input_mobile{
    color: #030303 !important;
}
.input_mobile::focus{   
    color: #030303 !important;
}
.input_mobile::active{   
    color: #030303 !important;
}
.input_mobile input{
    color: #030303 !important;
}
.input-tel{
    color: #030303 !important;
}
.input-tel__input{
    color: #030303 !important;
}
footer{
    padding: 100px 20px 40px 20px;
    text-align: center;
    background-color: #1f2730;
    color: rgba(255,255,255,0.8);
    a{
        color:#C33990;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/StarterLanding.vue